export function urlParam(param) {
  if (!param) {
    return null
  }

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  return urlParams.get(param)
}
